import React, { useEffect, useState } from "react";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import { hiring } from "./hiringApi";

const MEDIA = process.env.REACT_APP_BACKEND_URL;
const FIELDS = [["display_name", "Agency name (as applicants see it)"], ["intro", "Short introduction", 2], ["office_location", "Office location"], ["contact_email", "Contact email"],
  ["contact_phone", "Contact phone"], ["website", "Website (https://…)"], ["about", "About the Agency", 4], ["culture", "Workplace & culture", 3], ["recruiting_message", "Recruiting message", 2]];

export function EmployerProfile() {
  const [p, setP] = useState(null);
  const [edit, setEdit] = useState(false);
  useEffect(() => { hiring.get("/profile").then((r) => { setP({ display_name: r.data.agency_name, ...r.data.profile }); setEdit(r.data.can_edit); }).catch((e) => toast.error(apiError(e))); }, []);
  if (!p) return null;
  const set = (k) => (e) => setP({ ...p, [k]: e.target.value });
  const upload = (k) => async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    try { const r = await hiring.post("/profile/image", fd); setP({ ...p, [k]: r.data.url }); } catch (err) { toast.error(apiError(err)); }
  };
  const save = async () => { try { await hiring.put("/profile", p); toast.success("Employer profile saved"); } catch (e) { toast.error(apiError(e)); } };
  return (
    <div className="grid lg:grid-cols-3 gap-5" data-testid="employer-profile">
      <div className="lg:col-span-2 grid sm:grid-cols-2 gap-3">
        {FIELDS.map(([k, l, rows]) => (
          <label key={k} className={`block ${rows || k === "display_name" ? "sm:col-span-2" : ""}`}><span className="text-xs font-medium text-slate-600">{l}</span>
            {rows ? <Textarea rows={rows} value={p[k] || ""} onChange={set(k)} disabled={!edit} data-testid={`profile-${k}`} /> : <Input value={p[k] || ""} onChange={set(k)} disabled={!edit} data-testid={`profile-${k}`} />}</label>))}
        {edit && <Button onClick={save} className="sm:col-span-2 bg-brand hover:bg-brand-strong w-fit" data-testid="profile-save">Save profile</Button>}
      </div>
      <div className="space-y-4">
        {[["logo_url", "Logo"], ["photo_url", "Office or team photo"]].map(([k, l]) => (
          <div key={k} className="rounded-xl border border-slate-200 p-3">
            <p className="text-xs font-medium text-slate-600 mb-2">{l}</p>
            {p[k] ? <img src={`${MEDIA}${p[k]}`} alt={l} className="max-h-32 rounded-md object-contain" /> : <p className="text-xs text-slate-400">None yet</p>}
            {edit && <div className="flex gap-2 mt-2"><input type="file" accept="image/png,image/jpeg,image/webp" onChange={upload(k)} className="text-xs" data-testid={`profile-upload-${k}`} />
              {p[k] && <Button size="sm" variant="ghost" onClick={() => setP({ ...p, [k]: "" })}>Remove</Button>}</div>}
          </div>))}
        <p className="text-xs text-slate-500">This appears on your public job pages and in the Applicant Portal. Remember to save.</p>
      </div>
    </div>
  );
}

export function HiringAccess() {
  const [d, setD] = useState(null);
  useEffect(() => { hiring.get("/access").then((r) => setD(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!d) return null;
  const toggle = (uid, c) => setD({ ...d, staff: d.staff.map((s) => (s.user_id === uid ? { ...s, caps: s.caps.includes(c) ? s.caps.filter((x) => x !== c) : [...s.caps, c] } : s)) });
  const save = async () => { try { await hiring.put("/access", { access: Object.fromEntries(d.staff.map((s) => [s.user_id, s.caps])) }); toast.success("Hiring access saved"); } catch (e) { toast.error(apiError(e)); } };
  const L = { view: "View applicants", email: "Send recruiting emails", schedule: "Schedule interviews", status: "Update status / hire" };
  return (
    <div data-testid="hiring-access">
      <p className="text-sm text-slate-500 mb-3">Choose which Agency Staff can help with hiring. Staff have no hiring access until you turn it on.</p>
      {!d.staff.length ? <p className="text-sm text-slate-500 rounded-xl border border-dashed p-6 text-center">No Agency Staff with a Top-Recruit login yet.</p> :
        <div className="rounded-xl border border-slate-200 bg-white overflow-x-auto"><table className="w-full text-sm"><thead className="bg-slate-50 text-xs text-slate-500"><tr><th className="text-left p-3">Staff member</th>{d.caps.map((c) => <th key={c} className="p-3">{L[c]}</th>)}</tr></thead>
          <tbody>{d.staff.map((s) => <tr key={s.user_id} className="border-t"><td className="p-3">{s.name}</td>{d.caps.map((c) => <td key={c} className="p-3 text-center"><Checkbox checked={s.caps.includes(c)} onCheckedChange={() => toggle(s.user_id, c)} data-testid={`access-${c}-${s.user_id}`} /></td>)}</tr>)}</tbody></table></div>}
      {d.staff.length > 0 && <Button onClick={save} className="mt-3 bg-brand hover:bg-brand-strong" data-testid="access-save">Save access</Button>}
    </div>
  );
}
